// based on https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript

export const formatBytes = (bytes: number, decimals = 2) => {
  // avoid zero division
  if (bytes === 0) {
    return {
      value: '0',
      unit: 'Bytes',
    };
  }

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  const trailingDigits = decimals < 0 || decimals > 100 ? 2 : decimals; // fallback to 2 if illegal

  // fallback for unsupported unit
  if (index > sizes.length - 1) {
    return {
      value: `${parseFloat((bytes / Math.pow(1024, sizes.length - 1)).toFixed(trailingDigits))}`,
      unit: sizes[sizes.length - 1],
    };
  }

  return {
    value: `${parseFloat((bytes / Math.pow(1024, index)).toFixed(trailingDigits))}`,
    unit: sizes[index],
  };
};
